import Swiper from 'swiper';
import type { SwiperOptions } from 'swiper/types';
import { vars } from '@/app/config/variables';
import 'swiper/css';

export class ShippingGallery {
	private $container: HTMLElement;
	private swiperInstance: Swiper | null = null;
	private readonly tabletMQ: MediaQueryList;

	constructor(container: HTMLElement) {
		this.$container = container;
		this.tabletMQ = window.matchMedia(`(min-width: ${vars.breakpoint.tablet}px)`);

		this.init();
		this.tabletMQ.addEventListener('change', this.onMediaChange);
	}

	private init = (): void => {
		if (!this.tabletMQ.matches) {
			this.initGallery();
		}
	};

	private initGallery = (): void => {
		if (this.swiperInstance) return;

		const options: SwiperOptions = {
			slidesPerView: 'auto',
			allowTouchMove: true,
			grabCursor: true,
			loop: false,
			spaceBetween: 12,
		};

		this.swiperInstance = new Swiper(this.$container, options);
	};

	private destroyGallery = (): void => {
		if (this.swiperInstance) {
			this.swiperInstance.destroy(true, true);
			this.swiperInstance = null;
		}
	};

	private onMediaChange = (): void => {
		if (!this.$container) return;
		if (!this.tabletMQ.matches) {
			this.initGallery();
		} else {
			this.destroyGallery();
		}
	};

	public destroy = (): void => {
		this.destroyGallery();
		this.tabletMQ.removeEventListener('change', this.onMediaChange);
	};
}
